import React from 'react';
import User from "../../../components/pages/form/User/User";

const UserPage = () => {
    return <User />
};

export default UserPage;